import React from "react";
import { List, Text, ListItem } from "@chakra-ui/react";
import { LoadingOverlay } from "../LoadingOverlay";

export const CatalogList = ({ catalogs, catalogSelectCallback, loading }) => {
  return (
    <>
      {loading && <LoadingOverlay />}
      <Text fontSize="lg" fontWeight="bold" textAlign="center" pb="2">
        Catalogs
      </Text>
      <List width="100%">
        {catalogs.map((catalog) => (
          <ListItem
            key={catalog.id}
            cursor="pointer"
            onClick={() => catalogSelectCallback(catalog.id)}
            _hover={{
              background: "rgba(27,110,194, 0.8)",
              color: "#fff",
              borderRadius: "4px",
            }}
          >
            <Text fontSize="md" borderTop="1px solid #eee" padding="2">
              {catalog.catalogName}
            </Text>
          </ListItem>
        ))}
      </List>
    </>
  );
};
